import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { playSound } from '../utils'

import type { Order, OutletOrderExt } from './types'

// eslint-disable-next-line @typescript-eslint/no-var-requires
import sound from '../assets/mp3/new-order.mp3'

interface OrdersState {
  newOrders: string[]
}

// --- INITAL STATE --- //

export const initialState: OrdersState = {
  newOrders: [],
}

// --- SELECTORS --- //

export const getOutletOrders = (list: Order[], outletId: number): OutletOrderExt[] =>
  list.reduce((list: OutletOrderExt[], order) => {
    const outlet = order.order_outlets.find((outlet) => outlet.outlet_id === outletId)
    return outlet ? [...list, { ...outlet, order }] : list
  }, [])

// --- SLICE --- //

export const slice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    reset: (state) => {
      state.newOrders = []
    },

    addNewOrder: (state, { payload }: PayloadAction<string>) => {
      if (state.newOrders.includes(payload)) return
      state.newOrders.push(payload)
      playSound(new Audio(sound))
    },
    resetNewOrders: (state) => {
      state.newOrders = []
    },
  },
})
